module.exports = __webpack_public_path__ + "static/media/one.e276aac5.svg";